import { SET_NEW_RESERVATIONS_COUNT } from "../store/types";

const INITIAL_STATE = {
  newCount: 0,
};

export default function reservationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_NEW_RESERVATIONS_COUNT:
      return {
        ...state,
        newCount: action.payload,
      };
    default:
      return state;
  }
}
